export function matchShopDetailRoute(matchParam, value) {
    let result = false

    // console.log('🚀',matchParam, value)

    const styles = ['initial-necklaces', 'ready-to-ship-earrings', 'fashion-necklaces', 'soiree-cocktail-jewelry', 'soiree-cocktail-jewellery', 'colored-diamond-rings', 'wedding-band', 'womens-wedding-rings', 'couple-rings', 'eternity-rings', 'anniversary-rings', 'stud-earrings', 'hoop-earrings', 'fashion-earrings', 'tennis-bracelet', 'fashion-bracelets', 'tennis-necklace', 'solitaire-necklace', 'toi-et-moi-engagement-rings', 'ready-to-ship-engagement-rings', 'ready-to-ship-pendants', 'bangle-bracelets', 'rose-portrait-jewelry', 'rose-portrait-jewellery']

    if (matchParam === 'type') {

        result = styles.includes(value)
    }

    else if (matchParam === 'slug') {

        result = /\d+$/.test(value)
    }
    else if (matchParam === 'regx') {

        result = '/:type(initial-necklaces|ready-to-ship-earrings|fashion-necklaces|soiree-cocktail-jewelry|soiree-cocktail-jewellery|colored-diamond-rings|wedding-band|womens-wedding-rings|couple-rings|eternity-rings|anniversary-rings|stud-earrings|hoop-earrings|fashion-earrings|tennis-bracelet|fashion-bracelets|tennis-necklace|solitaire-necklace|toi-et-moi-engagement-rings|ready-to-ship-engagement-rings|ready-to-ship-pendants|bangle-bracelets|rose-portrait-jewelry|rose-portrait-jewellery)/:slug(.*-\\d+)'
    }

    return result
}